<template>
  <div class="max-w-5xl shadow entry-overview flex overflow-hidden bg-white sm:rounded-lg">
    <!-- Content area -->
    <div class="entry-detail w-full">
      <div class="flex flex-col">
        <main class="flex-1">
          <div class="relative md:px-8">
            <div class="pt-10 pb-16">
              <div class="px-4 sm:px-6 md:px-0">
                <p class="text-sm">
                  Project Plan <span class="text-gray-400">→ {{ project.name }}</span>
                </p>
                <h1 class="text-3xl font-bold tracking-tight text-gray-900">
                  {{ proposal.title }}
                </h1>
              </div>
              <div class="px-4 sm:px-6 md:px-0">
                <div class="py-6">
                  <!-- Tabs -->
                  <div class="lg:hidden">
                    <label
                      for="selected-tab"
                      class="sr-only">
                      Select a tab
                    </label>
                    <select
                      id="selected-tab"
                      name="selected-tab"
                      class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm">
                      <option
                        v-for="tab in tabs"
                        :key="tab.name"
                        :selected="(tab.name === 'Checklist')">
                        {{ tab.name }}
                      </option>
                    </select>
                  </div>
                  <div class="hidden lg:block">
                    <div class="border-b border-gray-200">
                      <nav class="-mb-px flex space-x-8">
                        <Link
                          v-for="tab in tabs"
                          :key="tab.name"
                          :href="tab.route ? route(tab.route) : tab.href"
                          :class="[(tab.name === 'Checklist') ? 'border-purple-500 text-purple-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm']">
                          {{ tab.name }}
                        </Link>
                      </nav>
                    </div>
                  </div>

                  <!-- ---- ---- Content START ---- ---- -->
                  <div>
                    <div class="relative z-0 flex flex-1 overflow-hidden">
                      <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none xl:order-last">
                        <!-- Breadcrumb -->
                        <nav
                          class="flex items-start px-4 py-3 border-b-4 border-gray-100 xl:hidden"
                          aria-label="Breadcrumb">
                          <a
                            href="#"
                            class="inline-flex items-center space-x-2 text-sm font-medium text-indigo-700">
                            <ChevronLeftIcon
                              class="-ml-2 h-5 w-5 text-indigo-500"
                              aria-hidden="true" />
                            <span>Tasks</span>
                          </a>
                        </nav>

                        <article
                          data-file="Test2.vue"
                          class="bg-gray-100 xl:bg-blue-100 pl-1">
                          <div class="p-5 xl:col-span-2 xl:border-r xl:border-b xl:border-gray-200 bg-white">
                            <div>
                              <div>
                                <div class="md:flex md:items-center md:justify-between md:space-x-4 xl:border-b xl:pb-6">
                                  <div>
                                    <p class="text-sm">
                                      Flight
                                    </p>
                                    <h1 class="text-2xl font-bold text-gray-900">
                                      Oslo → Copenhagen
                                    </h1>
                                    <p class="mt-2 text-sm text-gray-500">
                                      Assigned to
                                      {{ ' ' }}
                                      <a
                                        href="#"
                                        class="font-medium text-gray-900">Kim Sagbakken</a>
                                      {{ ' ' }}
                                      with due date
                                      {{ ' ' }}
                                      <a
                                        href="#"
                                        class="font-medium text-gray-900">01.12.2023</a>
                                    </p>
                                  </div>
                                </div>
                                <div class="py-3 xl:pt-6 xl:pb-0">
                                  <h2 class="sr-only">
                                    Description
                                  </h2>
                                  <div class="prose max-w-none">
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita, hic? Commodi cumque similique id tempora molestiae deserunt at suscipit, dolor voluptatem, numquam, harum consequatur laboriosam voluptas tempore aut voluptatum alias?</p>
                                    <ul role="list">
                                      <li>Tempor ultrices proin nunc fames nunc ut auctor vitae sed. Eget massa parturient vulputate fermentum id facilisis nam pharetra. Aliquet leo tellus.</li>
                                      <li>Turpis ac nunc adipiscing adipiscing metus tincidunt senectus tellus.</li>
                                      <li>Semper interdum porta sit tincidunt. Dui suspendisse scelerisque amet metus eget sed. Ut tellus in sed dignissim.</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <section
                              aria-labelledby="activity-title"
                              class="mt-8 xl:mt-10">
                              <div>
                                <div class="divide-y divide-gray-200">
                                  <div class="pb-4">
                                    <h2
                                      id="activity-title"
                                      class="text-lg font-medium text-gray-900">
                                      Subtasks
                                    </h2>
                                  </div>
                                  <div class="">
                                    <h2 class="sr-only">
                                      Subtasks
                                    </h2>
                                    <div class="prose max-w-none">
                                      <table class="min-w-full table-fixed divide-y divide-gray-300 border-b border-gray-200">
                                        <tbody class="divide-y divide-gray-200 bg-white ">
                                          <tr
                                            v-for="task in subtasks"
                                            :key="task.id"
                                            :class="[selectedTask.includes(task.id) && 'bg-gray-50']">
                                            <td class="relative w-10 px-4">
                                              <div
                                                v-if="selectedTask.includes(task.id)"
                                                class="absolute inset-y-0 left-0 w-0.5 bg-green-200" />
                                              <input
                                                v-model="selectedTask"
                                                type="checkbox"
                                                class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-green-200 focus:ring-green-400"
                                                :value="task.id">
                                            </td>
                                            <td :class="['whitespace-nowrap pl-1 pr-2 font-medium', selectedTask.includes(task.id) ? 'text-gray-400' : 'text-gray-900']">
                                              {{ task.title }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              aria-labelledby="activity-title"
                              class="mt-8 xl:mt-10">
                              <div>
                                <div class="divide-y divide-gray-200">
                                  <div class="pb-4">
                                    <h2
                                      id="activity-title"
                                      class="text-lg font-medium text-gray-900">
                                      Activity
                                    </h2>
                                  </div>
                                  <div class="pt-6">
                                    <!-- Activity feed-->
                                    <div class="flow-root">
                                      <ul
                                        role="list"
                                        class="-mb-8">
                                        <li
                                          v-for="(item, itemIdx) in activity"
                                          :key="item.id">
                                          <div class="relative pb-8">
                                            <span
                                              v-if="itemIdx !== activity.length - 1"
                                              class="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200"
                                              aria-hidden="true" />
                                            <div class="relative flex items-start space-x-3">
                                              <template v-if="item.type === 'comment'">
                                                <div class="relative">
                                                  <img
                                                    class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-400 ring-8 ring-white"
                                                    :src="item.imageUrl"
                                                    alt="">

                                                  <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
                                                    <ChatBubbleOvalLeftEllipsisIcon
                                                      class="h-5 w-5 text-gray-400"
                                                      aria-hidden="true" />
                                                  </span>
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                  <div>
                                                    <div class="text-sm">
                                                      <a
                                                        :href="item.person.href"
                                                        class="font-medium text-gray-900">{{ item.person.name }}</a>
                                                    </div>
                                                    <p class="mt-0.5 text-sm text-gray-500">
                                                      Commented {{ item.date }}
                                                    </p>
                                                  </div>
                                                  <div class="mt-2 text-sm text-gray-700">
                                                    <p>{{ item.comment }}</p>
                                                  </div>
                                                </div>
                                              </template>
                                              <template
                                                v-else-if="item.type === 'assignment'"
                                                condition="item.type === 'assignment'">
                                                <div>
                                                  <div class="relative px-1">
                                                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                                                      <UserCircleIcon
                                                        class="h-5 w-5 text-gray-500"
                                                        aria-hidden="true" />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="min-w-0 flex-1 py-1.5">
                                                  <div class="text-sm text-gray-500">
                                                    <a
                                                      :href="item.person.href"
                                                      class="font-medium text-gray-900">{{ item.person.name }}</a>
                                                    {{ ' ' }}
                                                    assigned
                                                    {{ ' ' }}
                                                    <a
                                                      :href="item.assigned.href"
                                                      class="font-medium text-gray-900">{{ item.assigned.name }}</a>
                                                    {{ ' ' }}
                                                    <span class="whitespace-nowrap">{{ item.date }}</span>
                                                  </div>
                                                </div>
                                              </template>
                                              <template v-else>
                                                <div>
                                                  <div class="relative px-1">
                                                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                                                      <DocumentPlusIcon
                                                        class="h-5 w-5 text-gray-500"
                                                        aria-hidden="true" />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="min-w-0 flex-1 py-0">
                                                  <div class="text-sm leading-8 text-gray-500">
                                                    <span class="mr-0.5">
                                                      <a
                                                        :href="item.person.href"
                                                        class="font-medium text-gray-900">{{ item.person.name }}</a>
                                                      {{ ' ' }}
                                                      attached
                                                    </span>
                                                    {{ ' ' }}
                                                    <span class="mr-0.5">
                                                      <template
                                                        v-for="file in item.files"
                                                        :key="file.name">
                                                        <a
                                                          :href="file.href"
                                                          class="relative inline-flex items-center rounded-full border border-gray-300 px-3 py-0.5 text-sm">
                                                          <span class="absolute flex flex-shrink-0 items-center justify-center">
                                                            <DocumentIcon
                                                              class="-ml-1 h-4 w-4 text-blue-500"
                                                              aria-hidden="true" />
                                                          </span>
                                                          <span class="ml-3.5 font-medium text-gray-600">{{ truncate(file.name, 30, "...") }}</span>
                                                        </a>
                                                        {{ ' ' }}
                                                      </template>
                                                    </span>
                                                    <span class="whitespace-nowrap">{{ item.date }}</span>
                                                  </div>
                                                </div>
                                              </template>
                                            </div>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                    <div class="mt-6">
                                      <div class="flex space-x-3">
                                        <div class="flex-shrink-0">
                                          <div class="relative">
                                            <img
                                              class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-400 ring-8 ring-white"
                                              src="https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80"
                                              alt="">

                                            <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
                                              <ChatBubbleOvalLeftEllipsisIcon
                                                class="h-5 w-5 text-gray-400"
                                                aria-hidden="true" />
                                            </span>
                                          </div>
                                        </div>
                                        <div class="min-w-0 flex-1">
                                          <form action="#">
                                            <div>
                                              <label
                                                for="comment"
                                                class="sr-only">Comment</label>
                                              <textarea
                                                id="comment"
                                                name="comment"
                                                rows="3"
                                                class="block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-900 focus:ring-gray-900 sm:text-sm"
                                                placeholder="Leave a comment" />
                                            </div>
                                            <div class="mt-6 flex items-center justify-end lg:space-x-4 flex-col-reverse lg:flex-row">
                                              <button
                                                type="button"
                                                class="my-2 lg:my-0 w-full lg:w-auto inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2">
                                                <ArrowUpTrayIcon
                                                  class="-ml-1 mr-2 h-5 w-5 text-gray-500"
                                                  aria-hidden="true" />
                                                <span>Upload file</span>
                                              </button>
                                              <button
                                                type="button"
                                                class="my-2 lg:my-0 w-full lg:w-auto inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2">
                                                <CheckCircleIcon
                                                  class="-ml-1 mr-2 h-5 w-5 text-green-500"
                                                  aria-hidden="true" />
                                                <span>Mark as resolved</span>
                                              </button>
                                              <button
                                                type="submit"
                                                class="my-2 lg:my-0 w-full lg:w-auto inline-flex items-center justify-center rounded-md border border-transparent bg-gray-900 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2">
                                                Comment
                                              </button>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </article>
                      </main>
                      <aside class="hidden w-96 flex-shrink-0 border-r border-gray-200 xl:order-first xl:flex xl:flex-col">
                        <div class="px-6 pt-6 pb-4 relative z-20">
                          <h2 class="text-lg font-medium text-gray-900">
                            Tasks
                          </h2>
                          <p class="mt-1 text-sm text-gray-600">
                            All activities, lodging, flights etc. appear here as assignable tasks. Click a task to see more details, comments and subtasks.
                          </p>
                          <SelectMenuWithSecondaryText
                            class="mt-2"
                            :items="taskAssignees"
                            label="Filter list by assignee:"
                            label-text-color="text-gray-500" />
                        </div>
                        <!-- Task list -->
                        <nav
                          class="min-h-0 flex-1 overflow-y-auto"
                          aria-label="Tasks">
                          <div
                            v-for="type in Object.keys(tasks)"
                            :key="type"
                            class="relative">
                            <div class="sticky top-0 z-10 border-t border-b border-gray-200 bg-gray-50 px-6 py-1 text-sm font-medium text-gray-500">
                              <h3>{{ type }}</h3>
                            </div>
                            <ul
                              role="list"
                              class="relative z-0 divide-y divide-gray-200">
                              <li
                                v-for="task in tasks[type]"
                                :key="task.id">
                                <div
                                  :class="(task.selected ? 'bg-blue-100' : '')"
                                  class="relative flex items-center space-x-3 px-6 py-5 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-100 hover:bg-blue-50">
                                  <div class="flex-shrink-0">
                                    <component
                                      :is="icons[task.icon]"
                                      v-if="task.icon"
                                      :class="[task.class, 'h-10 w-10']"
                                      aria-hidden="true" />
                                    <img
                                      v-else-if="task.imageUrl"
                                      class="h-10 w-10 rounded-full"
                                      :src="task.imageUrl"
                                      alt="">
                                  </div>
                                  <div class="min-w-0 flex-1">
                                    <a
                                      href="#"
                                      class="focus:outline-none">
                                      <!-- Extend touch target to entire panel -->
                                      <span
                                        class="absolute inset-0"
                                        aria-hidden="true" />
                                      <p class="text-sm font-medium text-gray-900">{{ task.name }}</p>
                                      <p class="truncate text-sm text-gray-500">{{ task.role }}</p>
                                    </a>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </nav>
                      </aside>
                    </div>
                  </div>
                  <!-- ---- ---- Content END ---- ---- -->
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
/* external */
import { ref, computed } from 'vue';
import { Link } from '@inertiajs/vue3';
import {
  CalendarIcon,
  BookOpenIcon,
  ChevronLeftIcon,
  CheckCircleIcon,
  CreditCardIcon,
  ArrowUpTrayIcon,
  HomeIcon,
  DocumentPlusIcon,
  PaperAirplaneIcon,
  DocumentIcon,
} from '@heroicons/vue/24/outline';
import {
  ChatBubbleOvalLeftEllipsisIcon,
  UserCircleIcon,
} from '@heroicons/vue/24/solid';

/* local */
import {
  tabs, subtasks, activity, tasks, project, proposal, taskAssignees,
} from './ProjectPlanDummy';
import FormattedDateRange from '@/ComponentsDeprecated/Time/FormattedDateRange';
import SelectMenuWithSecondaryText from '@/Components/Selectors/SelectMenuWithSecondaryText.vue';

const accessClient = ref(false);
const accessTourManager = ref(true);

const icons = {
  CalendarIcon,
  CheckCircleIcon,
  CreditCardIcon,
  PaperAirplaneIcon,
  HomeIcon,
  BookOpenIcon,
};

const selectedTask = ref([]);
const checked = ref(false);
const indeterminate = computed(() => selectedTask.value.length > 0 && selectedTask.value.length < people.length);

function truncate(text, length, suffix) {
  if (text.length > length) {
    return text.substring(0, length) + suffix;
  }

  return text;
}

</script>
